import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { SitesRouteNames, SitesRoutePathNames } from '../../enums';
import { beforeEnter } from './../guards';

const Component = () => import('./Station.vue');

export default {
  path: buildChildURL(
    SitesRoutePathNames.SITE,
    SitesRoutePathNames.STATION_DETAILS,
    SitesRoutePathNames.STATION,
  ),
  name: SitesRouteNames.SITE_STATION,
  component: Component,
  beforeEnter: beforeEnter,
} as RouteRecordRaw;
